/**
 * German speaking level
 *
 * Note: Keep the order of values descending as it's used for comparison in SQL and in
 * germanSpeakingLevelMatch (indexOf on Object.values().reverse()). The CEFR values are
 * interleaved at the same rank as their closest legacy value so existing comparisons
 * involving High/Mid/Low/None keep working once Docia candidates use the finer scale.
 */
export enum GermanSpeakingLevel {
  MotherTongue = 'mother_tongue',
  High = 'high',
  C2 = 'c2',
  C1 = 'c1',
  Mid = 'mid',
  B2 = 'b2',
  B1 = 'b1',
  Low = 'low',
  A2OrLower = 'a2_lower',
  None = 'none',
}

export const GERMAN_SPEAKING_LEVEL_I18N = {
  [GermanSpeakingLevel.MotherTongue]: 'Muttersprache',
  [GermanSpeakingLevel.High]: 'Muttersprachlich',
  [GermanSpeakingLevel.C2]: 'C2',
  [GermanSpeakingLevel.C1]: 'C1',
  [GermanSpeakingLevel.Mid]: 'Verhandlungssicher',
  [GermanSpeakingLevel.B2]: 'B2',
  [GermanSpeakingLevel.B1]: 'B1',
  [GermanSpeakingLevel.Low]: 'Grundkenntnisse',
  [GermanSpeakingLevel.A2OrLower]: 'A2 oder niedriger',
  [GermanSpeakingLevel.None]: 'Keine Kenntnisse',
};

/** Values only ever set by the Docia funnel; kept off Pflegia/Praxia selects and factories. */
export const DOCIA_GERMAN_SPEAKING_LEVELS = [
  GermanSpeakingLevel.A2OrLower,
  GermanSpeakingLevel.B1,
  GermanSpeakingLevel.B2,
  GermanSpeakingLevel.C1,
  GermanSpeakingLevel.C2,
  GermanSpeakingLevel.MotherTongue,
];

export const NON_DOCIA_GERMAN_SPEAKING_LEVELS = [
  GermanSpeakingLevel.High,
  GermanSpeakingLevel.Mid,
  GermanSpeakingLevel.Low,
  GermanSpeakingLevel.None,
];
